import { isArrayWithItems } from "../../../helpers";
import styles from "./slider.module.less";
import * as RadixSlider from "@radix-ui/react-slider";

export type TSliderProps = {
  value: number;
  min: number;
  max: number;
  step?: number;
  name: string;
  ariaLabel?: string;
  labels?: Array<string>;
  labelClassName?: string;
  onValueChange?: (value: Array<number>, name: string) => void;
};

export const Slider = ({
  name,
  labels,
  value,
  max = 100,
  min = 0,
  step = 1,
  ariaLabel,
  labelClassName,
  onValueChange,
}: TSliderProps) => {
  return (
    <div>
      <RadixSlider.Root
        className={styles.sliderRoot}
        value={[value]}
        name={name}
        max={max}
        min={min}
        step={step}
        onValueChange={(value) => onValueChange && onValueChange(value, name)}
      >
        <RadixSlider.Track className={styles.sliderTrack}>
          <RadixSlider.Range className={styles.sliderRange} />
        </RadixSlider.Track>
        <RadixSlider.Thumb className={styles.sliderThumb} aria-label={ariaLabel} />
      </RadixSlider.Root>
      {isArrayWithItems(labels) && (
        <ul className={styles.labels}>
          {labels.map((label) => {
            return <li className={[styles.label, labelClassName].join(" ")}>{label}</li>;
          })}
        </ul>
      )}
    </div>
  );
};

export default Slider;
